module.exports = __webpack_public_path__ + "static/media/Wolves927_2c2.50ba6652.svg";